import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5acd1f6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-aside-tools-inner" }
const _hoisted_2 = { class: "card enhanced-card" }
const _hoisted_3 = { class: "card-header bg-gradient p-3" }
const _hoisted_4 = { class: "header-content" }
const _hoisted_5 = { class: "task-definition-container" }
const _hoisted_6 = { class: "task-definition-content" }
const _hoisted_7 = { class: "task-definition-title" }
const _hoisted_8 = {
  key: 0,
  class: "label-column"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.visible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visible) = $event)),
      persistent: "",
      position: "right"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(`${_ctx.$t('main.label.of')} `) + " " + _toDisplayString(`${_ctx.$t(`task.actions.${_ctx.statusHistoryVariableSelected.taskDefinition}`)} `), 1)
                ])
              ]),
              _createVNode(_component_q_btn, {
                flat: "",
                round: "",
                dense: "",
                icon: "close",
                class: "close-btn",
                onClick: _ctx.closeStatusHistory,
                ripple: false
              }, null, 8, ["onClick"])
            ])
          ]),
          _createVNode(_component_q_table, {
            rows: _ctx.rows,
            columns: _ctx.columns,
            "row-key": "id",
            "hide-pagination": "",
            pagination: _ctx.pagination,
            "onUpdate:pagination": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pagination) = $event)),
            class: "shadow-1 table table-sm bg-light mb-0 enhanced-table"
          }, {
            header: _withCtx((props) => [
              _createVNode(_component_q_tr, { props: props }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cols, (col) => {
                    return (_openBlock(), _createBlock(_component_q_th, {
                      key: col.name,
                      props: props
                    }, {
                      default: _withCtx(() => [
                        (col.name !== 'actions')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t(col.label)), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["props"]))
                  }), 128)),
                  _createVNode(_component_q_th, { "auto-width": "" })
                ]),
                _: 2
              }, 1032, ["props"])
            ]),
            body: _withCtx((props) => [
              _createVNode(_component_q_tr, { props: props }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cols, (col) => {
                    return (_openBlock(), _createBlock(_component_q_td, {
                      key: col.name,
                      props: props
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(col.value), 1)
                      ]),
                      _: 2
                    }, 1032, ["props"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["props"])
            ]),
            _: 1
          }, 8, ["rows", "columns", "pagination"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}